import {InjectionToken} from '@angular/core';

export const WEBSOCKET_URL = new InjectionToken<string>('WEBSOCKET_URL');
